<template>
  <div class="menu-search">
    <i class="fal fa-search menu-search-icon"></i>
    <input
      :value="value"
      type="text"
      class="menu-search-input"
      :placeholder="placeholder"
      @input="emitValue"
    />
  </div>
</template>

<script>
export default {
  name: 'MenuSearch',
  meta: {
    description: 'Campo de búsqueda de los menús de módulo.',
  },
  props: {
    value: {
      type: String,
      default: '',
      meta: {
        description: 'Texto de búsqueda (v-model)',
        example: 'this.searchQuery',
      },
    },
    placeholder: {
      type: String,
      default: 'Búsqueda',
      meta: {
        description: 'Establece el texto guía del campo',
        example: 'Búsqueda',
      },
    },
  },
  methods: {
    emitValue(event) {
      this.$emit('input', event.target.value);
    },
  },
};
</script>

<style scoped>
.menu-search {
  position: relative;
  width: 100%;
  max-width: 260px;
  margin-bottom: 15px;
}

.menu-search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #ff7058;
  font-size: 14px;
}

.menu-search-input {
  width: 100%;
  padding: 8px 16px 8px 36px;
  border: 1px solid #ff7058;
  border-radius: 20px;
  outline: none;
  font-size: 14px;
}

.menu-search-input::placeholder {
  color: #a9a9a9;
}
</style>
